import {
  BUTTON,
  RADIO,
  COMPONENT,
  CHECKBOX,
  OPTIN_HCP,
  INFORMATION_CONSENT,
  commonShouldHaveValue,
  SHOULD_ACCEPT_CONSENT,
  CONSENT_FORM,
  SHOULD_HAVE_VALUE_RADIO,
} from 'components/shared/form/formConstants';
import { useWebsiteConfigObject } from 'websiteConfig/useWebsiteConfig';
import { WithdrawConsent } from 'components/pageTemplates/login/WithdrawConsent';
import { MandatoryKey } from 'components/pageTemplates/login/MandatoryKey';
import { TermsLabel } from 'components/pageTemplates/login/Terms-label';
import { PrivacyConsent } from 'components/pageTemplates/login/PrivacyConsent';
import { MarketingLabel } from 'components/pageTemplates/login/Marketing-label';
import { MarketingConsent } from 'components/pageTemplates/login/MarketingConsent';
import { getLocationOrigin, getUrlCountryPath } from 'utils/urlUtils';
const useConsentFormFields = () => {
  const {
    tConsentFormTitle,
    tConsentFormText,
    tConsentFormHcpConsentText,
    tConsentFormMarketingConsentText,
    tConsentFormButtonText,
    tThisFieldIsRequired,
    tmarketingPreferenceErrorMessage,
    disableMarketingConsent,
    featureSwitchNewConsent,
    promotionalMaterialsLabel,
    medicalScientificLabel,
  } = useWebsiteConfigObject();

  console.log('disableMarketingConsent', disableMarketingConsent);

  const formFields = [
    {
      id: 'terms-label',
      type: COMPONENT,
      size: 100,
      typeParams: {
        PropComponent: TermsLabel,
      },
    },
    {
      id: 'privacy-text',
      type: COMPONENT,
      size: 100,
      typeParams: {
        PropComponent: PrivacyConsent,
      },
    },
    {
      label: '',
      id: OPTIN_HCP,
      initialValue: '',
      type: RADIO,
      mandatory: true,
      typeParams: {},
      validation: [
        {
          validationMethodKey: SHOULD_ACCEPT_CONSENT,
          errorText: tThisFieldIsRequired
            ? tThisFieldIsRequired
            : 'This field is required',
        },
      ],
    },
    {
      id: 'marketing-label',
      type: COMPONENT,
      size: 100,
      typeParams: {
        PropComponent: MarketingLabel,
      },
      disabled: disableMarketingConsent,
    },
    {
      id: 'marketing-text',
      type: COMPONENT,
      size: 100,
      typeParams: {
        PropComponent: MarketingConsent,
      },
      disabled: disableMarketingConsent,
    }
  ];

  if (featureSwitchNewConsent) {
    formFields.push(
      {
        label: promotionalMaterialsLabel,
        id: 'promotionalMaterialsOptIn',
        initialValue: false,
        type: 'checkbox',
        mandatory: false,
        typeParams: {},
        validation: [],
      },
      {
        label: medicalScientificLabel,
        id: 'medEdMaterialsOptIn',
        initialValue: false,
        type: 'checkbox',
        mandatory: false,
        typeParams: {},
        validation: [],
      }
    );
  } else {
    formFields.push({
      id: 'informationConsent',
      initialValue: disableMarketingConsent ? null : false,
      type: RADIO,
      // mandatory: false,
      typeParams: {},
      // validation: [{
      //   validationMethodKey: SHOULD_HAVE_VALUE_RADIO,
      //   errorText: tmarketingPreferenceErrorMessage ? tmarketingPreferenceErrorMessage : 'Please select either "Yes" or "No"',
      // }],
      disabled: disableMarketingConsent,
    });
  }

  formFields.push(
    {
      id: 'withdraw-consent',
      type: COMPONENT,
      typeParams: {
        PropComponent: WithdrawConsent,
      },
    },
    {
      id: 'consent-continue',
      type: BUTTON,
      size: 50,
      typeParams: {
        callBack: ({ formValues, actions }) => {
          actions.updateConsent({ formValues });
        },
        text: tConsentFormButtonText,
        type: 'button',
      },
    },
    {
      id: 'mandatory-key',
      type: COMPONENT,
      size: 100,
      typeParams: {
        PropComponent: MandatoryKey,
      },
    }
  );

  const consentFormFields = [
    {
      id: CONSENT_FORM,
      formHeaderText: tConsentFormTitle,
      formDescription: tConsentFormText,
      formFields: formFields,
    },
  ];

  // Remove INFORMATION_CONSENT if locale is fr-fr
  consentFormFields[0].formFields = consentFormFields[0].formFields.filter(
    (field) => {
      if (getUrlCountryPath()?.toLowerCase() === 'fr-fr') {
        return field.id !== INFORMATION_CONSENT;
      }
      return true;
    }
  );

  return consentFormFields;
};

export { useConsentFormFields };
